export const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';

export async function authFetch(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });

  if (response.status === 401) {
    window.location.href = '/login';
    throw new Error('Session expired');
  }

  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      const body = await response.clone().json();
      if (body.detail) {
        detail = Array.isArray(body.detail)
          ? body.detail.map(e => `${e.loc?.slice(-1)[0] ?? ''}: ${e.msg}`).join('; ')
          : body.detail;
      }
    } catch (_) { /* ignore parse errors, use fallback message */ }
    const err = new Error(detail);
    err.status = response.status;
    throw err;
  }

  return response;
}
